module.exports = __webpack_public_path__ + "img/logo_dir.4ffc66d6.png";